module.exports = __webpack_public_path__ + "static/media/new-home-banner.377f098c.jpg";